<template>
	<el-form class="login-form"
			:model="loginForm"
			ref="loginForm"
			:rules="loginRules"
			:label-width="labelWidth">
		<el-form-item :label="$t('create.text.setPassword') | withColon">
			<input type="radio" v-model="loginForm.passwordType" value="pwd" id="pwd"/>
			<label for="pwd">
				{{ $t('create.text.customizedPassword') }}
			</label>
			<input v-if="operate !=='Windows' && operate !=='WindowsPC'" type="radio" v-model="loginForm.passwordType" value="keyPair" id="keyPair"
						class="auto-password-position"/>
			<label v-if="operate !=='Windows' && operate !=='WindowsPC'" for="key">
				{{ $t('create.text.publicKey') }}
			</label>
			<el-tooltip style="margin-left:10px" effect="dark" placement="right">
				<div slot="content" class="my-os-disk-tip">
					{{$t('create.tooltip.keyPairTip')}}
				</div>
				<a><i class="jc-icon-question"></i></a>
			</el-tooltip>
		</el-form-item>
		<!--用户名-->
		<el-form-item :label="$t('create.text.username')|withColon"
			v-if="loginForm.passwordType === 'pwd'">
			<span>{{ 'root' }}</span>
		</el-form-item>
		<div v-if="loginForm.passwordType === 'pwd'">
			<!--密码-->
			<el-form-item :label="$t('privateNetInstance.password') | withColon"
				prop="password">
				<el-input v-model="loginForm.password" type="password"></el-input>
				<p slot="hint">{{ $t('privateNetInstance.passwordTip') }}</p>
			</el-form-item>
			<!--确认密码-->
			<el-form-item :label="$t('privateNetInstance.repassword') | withColon"
				prop="repassword">
				<el-input v-model="loginForm.repassword" type="password"></el-input>
			</el-form-item>
		</div>
		<el-form-item :label="$t('create.text.linkSSHKey') | withColon" v-if="loginForm.passwordType !== 'keyPair'">
			<el-switch
				v-model="setKeyState"
				on-text=""
				off-text=""
				:disabled="operate ==='Windows'  || operate === 'WindowsPC'">
			</el-switch>
			<el-tooltip style="margin-left:10px" effect="dark" placement="right">
				<div slot="content" class="my-os-disk-tip">
				{{$t('create.tooltip.keyPairTips')}}
				</div>
				<a><i class="jc-icon-question"></i></a>
			</el-tooltip>
			<p v-if="!setKeyState">{{$t('create.text.keyTips')}}</p>
		</el-form-item>
		<div>
			<!--密钥对-->
			<el-form-item :label="$t('create.text.key') | withColon"
				v-if="setKeyState && loginForm.passwordType !== 'keyPair'"
				prop="selectKey"
				:show-message="false">
				<el-select v-model="loginForm.selectKey" class="select-vpc"
					@visible-change="getRealTimePublicKey"
					@change="keyChange"
					:placeholder="$t('listPage.placeholder.choose')">
					<el-option v-for="(key, index) in keyShowList"
						:key="index"
						:label="key.name"
						:value="key.keypairId">
					</el-option>
				</el-select>
				<el-button type="text" @click="jumpToKeys" class="ml10">
				{{ $t('ssh.text.create') }}
				</el-button>
				<p class="el-form-item-like">
					{{$t('create.help.publicKeySetting')}}
					<a :href="Config.SSH_HELP_URL"
						target="_blank">
						{{$t('privateNetInstance.operateGuid')}}
					</a>
				</p>
			</el-form-item>
			<!--密钥对多选-->
			<el-form-item :label="$t('create.text.key') | withColon"
				v-if="loginForm.passwordType === 'keyPair'"
				prop="selectKey"
				:show-message="false">
				<secret-key :region="region"
					v-model="loginForm.selectKey"
				></secret-key>
			</el-form-item>
			<!--SOS密钥对-->
			<el-form-item :label="$t('privateNetInstance.SOSKeyPair') | withColon"
				v-if="loginForm.passwordType === 'keyPair'"
				prop="sosKey"
				:show-message="false">
				<sos-secret-key :region="region"
					v-model="loginForm.sosKey"
				></sos-secret-key>
			</el-form-item>
		</div>
	</el-form>
</template>

<script>
import SecretKey from '@/components/common/secretKey/SecretKey';
import SosSecretKey from '@/components/common/sosSecretKey/SosSecretKey';
import { PasswordRuleConstant } from '@/common/Constants';
export default {
	name: 'LoginMethods',
	components: {
		SecretKey,
		SosSecretKey
	},
	props: {
		region: {
			type: String,
			default: ''
		},
		operate: {
			type: String,
			default: ''
		},
		pageType: {
			type: String,
			default: ''
		}
	},
	data() {
		/**
		 * 校验密码
		 * @param rule
		 * @param value
		 * @param callback
		 */
		const valPas = (rule, value, callback) => {
			const pasRule = PasswordRuleConstant;
			if (!value) {
				callback(this.$t('privateNetwork.passwordNotNull'));
			} else if (!pasRule.test(value)) {
				callback(this.$t('privateNetInstance.passwordTip'));
			} else {
				callback();
			}
		};
		/**
		 * 确认密码校验，且在校验通过后将密码传给父组件
		 * @param rule
		 * @param value
		 * @param callback
		 */
		const valRepas = (rule, value, callback) => {
			if (!value) {
				callback(this.$t('privateNetwork.repasswordNotNull'));
			} else if (value !== this.loginForm.password) {
				callback(this.$t('privateNetwork.repasswordNotPass'));
			} else {
				if(this.setKeyState===true) {
					this.$emit('getPassword', this.loginForm.passwordType, this.loginForm.repassword, this.loginForm.selectKey);
				}else{
					this.$emit('getPassword', this.loginForm.passwordType, this.loginForm.repassword, '' );
				}
				callback();
			}
		};
		return {
			loginForm: {
				passwordType: 'pwd', // 类型，默认自定义密码
				password: '',
				repassword: '',
				publicKey: [], // 密钥列表
				selectKey: '', // 选中的密钥对
				sosKey: '', // sos密钥对
			},
			// form中绑定的数据
			loginRules: {
				password: [
					{ required: true, message: this.$t('privateNetwork.passwordNotNull'), trigger: 'blur' },
					{ validator: valPas, trigger: 'blur' }
				],
				repassword: [
					{ required: true, message: this.$t('privateNetwork.repasswordNotNull'), trigger: 'blur' },
					{ validator: valRepas, trigger: 'blur' }
				],
				selectKey: [
					{ required: true, trigger: 'change' },
				],
				sosKey: [
					{ required: true, trigger: 'change' },
				]
			}, // 校验规则
			setKeyState: true, //ssh密钥
		};
	},
	methods: {
		/**
		 * 当选中值发生变化时调用
		 * 主要是校验通过后给父组件传值
		 * @param keypairId
		 */
		keyChange(keypairId) {
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					this.loginForm.selectKey = keypairId
				}
			});
		},
		/**
		 * 获得密钥对
		 * 当登陆方式为'密钥登陆'时调用
		 * 没有分页，所以pageSize为200
		 */
		getPublicKey() {
			const params = {
				region: this.region,
				pageSize: 200
			};
			Ajax.get('/api/cps/listKeypairs', params)
				.then((res) => {
					this.loginForm.publicKey = res.data.keypairs;
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		/**
		 * 密钥对select为下拉状态时调用
		 * 获得最新密钥对信息
		 * @param tag
		 */
		getRealTimePublicKey(tag) {
			if (tag) {
				this.getPublicKey();
			}
		},
		/**
		 * 跳转密钥列表
		 */
		jumpToKeys() {
			this.$router.push({
				path: '/ssh/list',
				query: {
					region: this.region
				}
			});
		}
	},
	computed: {
		/**
		 * 密钥对下拉列表
		 * @return array
		 */
		keyShowList() {
			if (this.loginForm.publicKey.length) {
				return this.loginForm.publicKey.map(key => ({
					keypairId: key.keypairId,
					name: key.name,
					publicKey: key.publicKey
				}));
			}
			return [{
				name: this.$t('listPage.placeholder.choose'),
				keypairId: null
			}];
		},

		labelWidth() {
			return 	this.pageType='privateNetInstance'? '150px': '120px'
		}
	},
	watch: {
		/**
		 * 登陆方式改变时调用，暂时找不到@change
		 * @param newVal
		 */
		'loginForm.passwordType': function () {
			this.loginForm.selectKey = '';
			this.loginForm.password = '';
			this.loginForm.repassword = '';
			this.$refs.loginForm.clearValidate(['password', 'repassword', 'selectKey']);
		},
		'loginForm.selectKey': function () {
			if(this.loginForm.passwordType==="keyPair") {
				this.$emit('getPassword', this.loginForm.passwordType, '', this.loginForm.selectKey, this.loginForm.sosKey);
			}
		},
		'loginForm.sosKey': function () {
			this.$emit('getPassword', this.loginForm.passwordType, '', this.loginForm.selectKey, this.loginForm.sosKey);
		},
		setKeyState() {
			this.$refs.loginForm.clearValidate(['selectKey']);
			this.loginForm.selectKey = '';
		},
		operate(val) {
			if(val ==="Windows" ||  val === "WindowsPC") {
				this.setKeyState = false;
				this.loginForm.selectKey = '';
			}else {
				this.setKeyState = true;
			}
		}
	}
};
</script>

<style scoped lang="scss">
	.login-form {

		.el-select {
			width: 320px !important;
		}
		.el-input {
			width: 320px !important;
		}

		.el-form-item-like {
			line-height: 16px;
			padding-top: 10px;
			font-size: 12px;
			margin: 0;
			color: #9e9e9e
		}
		// 设置密码两个radio之间的距离
		.auto-password-position {
			margin-left: 15px;
		}
		// 密钥登录提示
		.key-pairs-position {
			margin-left: 112px;
			color: red;
		}

		.ml10 {
			margin-left: 10px;
		}
		// jc-select

	}
</style>



// WEBPACK FOOTER //
// src/components/common/loginMethods/LoginMethods.vue